<template>
    <v-dialog
        :model-value="showModal"
        @update:model-value="closeModal"
        :fullscreen="$vuetify.display.mobile"
        :max-width="$vuetify.display.mobile ? '100%' : '600'"
        persistent
    >
        <v-card>
            <v-card-title class="headline">
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <span>New SDK Key</span>
                    <v-btn icon @click="closeModal">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <v-form id="sdk-key-form" @submit.prevent="submitSdkKeysForm">
                    <v-text-field
                        v-model="sdkKeyForm.name"
                        label="SDK Key Name"
                        id="sdk-key-name"
                        class="mt-5"
                        test-id="sdk-key-input-name"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="sdkKeyForm.bundle"
                        label="Bundle ID"
                        id="bundle-id"
                        :class="{ 'is-invalid': !isBundleIdValid }"
                        @input="hasStartedTyping = true"
                        test-id="sdk-key-input-bundle"
                        style="font-family: monospace"
                        required
                    ></v-text-field>
                    <div class="invalid-feedback" v-if="!isBundleIdValid && hasStartedTyping">
                        Bundle ID must contain only alphanumeric characters, hyphens, and periods.
                    </div>
                    <toggle-switch
                        v-model="sdkKeyForm.improvedBilling"
                        label="Billing Type"
                        :label-on="'Improved Billing (ExtractMesh)'"
                        :label-off="'Legacy Billing (AccessToMesh)'"
                        :testId="'sdk-key-toggle-billing'"
                    ></toggle-switch>
                    <v-btn id="sdk-key-submit" type="submit" :disabled="!isBundleIdValid" color="primary">Submit</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
	import { ref, computed } from 'vue';
	import ToggleSwitch from '@/components/forms/ToggleSwitch.vue';

	export default {
		name: 'DynamicFormModal',
		components: {
			ToggleSwitch,
		},
					props: {
						showModal: Boolean,
						emitFunction: Function,
					},
					setup(props, context) {
						const BUNDLE_ID_REGEX = /^[a-zA-Z0-9.-]+$/;
						const hasStartedTyping = ref(false);
						const icon = (icon) => require(`@/assets/images/icons/${icon}.svg`);
						const sdkKeyForm = ref({
							name: '',
							bundle: '',
							improvedBilling: false,
						});

						const validateBundleId = (bundleId) => {
							return BUNDLE_ID_REGEX.test(bundleId);
						}

						const isBundleIdValid = computed(() => {
							return validateBundleId(sdkKeyForm.value.bundle);
						});


						const closeModal = () => {
							context.emit('update:showModal', false);
						}

						const submitSdkKeysForm = () => {
							if (isBundleIdValid.value) {
								props.emitFunction('submit-sdk-keys-form', sdkKeyForm.value);
								closeModal();
							}
						}

						const openInfoUrl = () => {
							window.open('https://support.structure.io/article/533-what-are-mesh-access-billing-and-mesh-extraction-billing', '_blank');
						}


						return {
							sdkKeyForm,
							isBundleIdValid,
							hasStartedTyping,
							closeModal,
							submitSdkKeysForm,
							icon,
							openInfoUrl,
						};
					},
				};
		</script>